<template>
    <div class="wrap">
        <div>
            <div>
                <el-button @click="addFood" type="primary" icon="el-icon-circle-plus-outline">添加菜品</el-button>
            </div>
        </div>
        <div class="mt10">
            <el-collapse v-model="activeNames" @change="collapseChange" v-loading="pageLoading">
                <el-collapse-item v-for="(foodList, index) in foodListData" :key="index" :title="foodList.label" :name="index">
                    <el-row>
                        <el-col :span="span" v-for="(foodItem, index) in foodList.value" :key="index" class="mb20">
                            <el-card :body-style="{ padding: '0px' }" class="card">
                                <el-image v-if="foodItem.fileUrl" :src="baseUrl+'/'+foodItem.fileUrl + '?x-oss-process=image/resize,s_200'" class="image" fit="cover"></el-image>
                                <div style="padding: 10px;">
                                    <div class="card-text">{{foodItem.name}}</div>
                                    <div class="bottom clearfix">
                                        <div :title="foodItem.foodMaterials" class="card-text">食材用料: {{foodItem.foodMaterials}}</div>
                                    </div>
                                </div>
                                <div v-if="foodItem" class="img-board">
                                    <div @click="editFood(foodItem)" class="icon edit-icon"><i class="el-icon-edit"></i></div>
                                    <div v-if="foodItem.fileUrl" @click="zoomIn(foodList.label+'-'+foodItem.name, baseUrl+'/'+foodItem.fileUrl)" class="icon zoom-in-icon"><i class="el-icon-zoom-in"></i></div>
                                    <div @click="delFood(foodItem.id)" class="icon close-icon"><i class="el-icon-delete"></i></div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-dialog v-if="dialogVisible" :close-on-click-modal="false" :visible.sync="dialogVisible" :title="imgTitle" style="padding-top: 0px;">
                <el-image :src="imgSrc" fit="cover" style="width: 100%;"></el-image>
            </el-dialog>
            <food-dialog v-if="foodDialogVisible" :foodData="foodData" :food-dialog-visible="foodDialogVisible" @closeFoodDialog="closeFoodDialogVisible"></food-dialog>
        </div>
        
    </div>
</template>
<script>
import {enumList} from '@/utils/enumList'
import FoodDialog from './FoodDialog'
import * as foodApi from '@/api/food'
export default {
    components: {
        FoodDialog
    },
    data() {
        return {
            activeNames: [],
            baseUrl: '',
            imgSrc: '',
            foodListData: [],
            imgTitle: '',
            pageLoading: false,
            dialogVisible: false,
            foodData: {
                type: '',
                data: {}
            },
            foodDialogVisible: false,
            screenWidth: document.body.clientWidth,
            timer: false
        }
    },
    computed: {
        span: function() {
            let colNum = parseInt(this.screenWidth/300)
            return parseInt(24/colNum)
        }
    },
    methods: {
        // 面板折叠
        collapseChange(val) {

        },
        // 添加菜品
        addFood() {
            this.foodData.type = 'isAdd';
            this.foodDialogVisible = true;
        },
        // 获取列表数据
        async getFoodList() {
            await foodApi.categoryList().then(r => {
                if(r.code === 200) {
                    let obj = r.data;
                    let propertys = [];
                    let activeNames = [];
                    let result = Object.keys(obj).sort().map((el, index) => {
                        let propertysItem = {'label': enumList.foodType[el], 'value': obj[el]};
                        propertys.push(propertysItem);
                        if(obj[el]) { // 面板有值则展开
                            activeNames.push(index);
                        }
                    });
                    this.activeNames = activeNames;
                    this.foodListData = propertys;
                    this.pageLoading = false;
                }
            }).catch(e=>{})
        },
        // 图片放大
        zoomIn(title, src) {
            this.imgTitle = title;
            this.imgSrc = src;
            this.dialogVisible = true;
        },
        // 编辑菜品
        editFood(row) {
            this.foodDialogVisible = true;
            this.foodData.type = 'isEdit';
            this.foodData.data = row;
        },
        // 删除
        delFood(id) {
            this.$confirm('是否确认删除菜品? 此操作不可恢复!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                foodApi.categoryDel({id: id}).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功!');
                        this.getFoodList();
                    }
                })
            }).catch(e => {})
        },
        // 关闭dialog
        closeFoodDialogVisible() {
            this.foodDialogVisible = false;
        },
        getBaseUrl() {
            this.pageLoading = true;
            foodApi.findBaseUrl().then(r=>{
                if(r.code === 200) {
                    this.baseUrl = r.data.baseUrl;
                    this.$store.state.user.imgBaseUrl = this.baseUrl;
                    // 获取列表数据
                    this.getFoodList();
                }
            }).catch(e=>{})
        }
    },
    mounted() {
        // 获取图片baseUrl
        this.getBaseUrl();
        // 菜品库列数自适应屏幕宽度
        window.onresize = () => {
            if (!this.timer) {
                this.timer = true
                setTimeout(() => {
                    this.timer = false
                    this.screenWidth = document.body.clientWidth
                }, 500)
            }
        };
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
        .button {
            padding: 0;
            float: right;
        }
        .card {
            width: 240px;
            height: 270px;
            background-color: #333333;
            border: 1px solid #333333;
        }
        .card-text {
            color: #FFFFFF;
            font-size: 12px;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
        }
        // .card-text:hover{
        //     cursor: pointer;
        //     color: #178CFA;
        // }
        .image {
            width: 100%;
            height: 200px;
            display: block;
        }
        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }
        .clearfix:after {
            clear: both
        }
        .img-board {
            background-color:black;
            width: 240px;
            height: 200px;
            position: relative;
            margin-top: -290px;
            opacity: 0.6;
            display: none;
            div {
                font-size: 24px;
                font-weight: 700;
                color: #FFFFFF;
                :hover {
                    cursor: pointer;
                    color: #178CFA;
                }
            }
            .icon {
                text-align: center;
                display: inline-block;
                width: 30px;
                line-height: 30px;
                font-size: 30px;
                margin-top: 40%;
                margin-left: 15%;
            }
        }
        .card:hover .img-board{
            display: block;
        }
    }
</style>